import { ExtraDto } from '../dtos';
import { Extra } from '@core/models/extra.model';

export function toExtraDto(extra: Extra): ExtraDto {
  return <ExtraDto>{
    extraId: extra.extraId,
    name: extra.name,
  };
}
